/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import VasSheetAsync from 'Components/VasSheet/VasSheetAsync';
import PropTypes from 'prop-types';
import { VAS_HASH, GALLERY_HASH, MISSED_RESERVE_HASH } from 'Constants/items';
import AdpvMX from './adpvMXComponents/AdpvMX.APP_TARGET';
import useBackButtonHandling from 'Hooks/useBackButtonHandling/useBackButtonHandling';
import withRouter from 'HOCs/withRouter';
import { compose } from 'redux';
import withConfig from 'HOCs/withConfig/withConfig';
import { getIsSpinCarEnabled } from 'Helpers/item';

export const AdpvMXContainer = props => {
    const [leadHash, setLeadHash] = useState('');
    const {
        router,
        location,
        config,
        itemId,
        isShowCoachMark,
        onCloseMarkCoach,
        isShowReservationButton,
        isItemReserved,
        escrowTrack,
        ...restProps
    } = props;
    const {
        isOpened: isVasSheetOpened,
        closeModal: closeVasSheet,
        openModal: openVasSheet,
        removeHash
    } = useBackButtonHandling({
        router,
        location,
        overlayHash: VAS_HASH
    });

    const {
        isOpened: isGalleryOverlayOpened,
        closeModal: closeGalleryOverlay,
        openModal: openGalleryOverlay
    } = useBackButtonHandling({
        router,
        location,
        overlayHash: GALLERY_HASH
    });

    const {
        closeModal: closeLead,
        openModal: openLead
    } = useBackButtonHandling({
        router,
        location,
        overlayHash: leadHash
    });

    const {
        isOpened: isMissedReserveOpened,
        closeModal: closeMissedReserve
    } = useBackButtonHandling({
        router,
        location,
        overlayHash: MISSED_RESERVE_HASH
    });

    const setLeadFormHash = leadFormHash => {
        setLeadHash(leadFormHash);
    };

    const isSpinCarEnabled = getIsSpinCarEnabled(config);

    useEffect(() => {
        removeHash();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [fireMakeOffer, setFireMakeOffer] = useState(false);
    const newVasBanner = config.get('olxAutos', 'newVasBanner');
    const siteCode = config.get('siteCode');
    const isOlxMobbi = config.get('isOlxMobbi');

    return (
        <>
            <AdpvMX
                openModal={ openVasSheet }
                openGalleryOverlay={ openGalleryOverlay }
                isGalleryOverlayOpened={ isGalleryOverlayOpened }
                closeGalleryOverlay={ closeGalleryOverlay }
                openLead={ openLead }
                closeLead={ closeLead }
                leadHash={ leadHash }
                isSpinCarEnabled={ isSpinCarEnabled }
                fireMakeOffer={ fireMakeOffer }
                onSetFireMakeOffer={ setFireMakeOffer }
                setLeadFormHash={ setLeadFormHash }
                closeMissedReserve={ closeMissedReserve }
                isMissedReserveOpened={ isMissedReserveOpened }
                isOlxMobbi={ isOlxMobbi }
                isShowCoachMark={ isShowCoachMark }
                onCloseMarkCoach={ onCloseMarkCoach }
                isShowReservationButton={ isShowReservationButton }
                isItemReserved={ isItemReserved }
                escrowTrack={ escrowTrack }
                { ...restProps }
            />
            <VasSheetAsync
                isOpened={ isVasSheetOpened }
                onVasBottomSheetClose={ closeVasSheet }
                isNewUspVasDesign={ newVasBanner }
                siteCode={ siteCode }
                selectedItemId={ itemId }
                isFromAdpv
            />
        </>
    );
};

AdpvMXContainer.propTypes = {
    isOpened: PropTypes.bool,
    router: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    itemId: PropTypes.string,
    isShowCoachMark: PropTypes.bool,
    onCloseMarkCoach: PropTypes.func,
    isShowReservationButton: PropTypes.bool,
    isItemReserved: PropTypes.bool,
    escrowTrack: PropTypes.func
};

export default compose(
    withConfig,
    withRouter
)(AdpvMXContainer);
